import { FadeUp, MaskedLine, MonoLabel } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How do we work together?",
    a: "Two ways. If you already have a marketing team, I plug into it. I set the strategy, your team executes, and I track real KPIs with you. If you don't have a team, mine does the work for you. You assign one person I report to, and I keep going until I deliver what we agreed on.",
  },
  {
    q: "What if you don't deliver?",
    a: "I ask for a minimum commitment of 8 months, because that's how long this kind of work takes. If I haven't delivered what I promised by then, I keep working for free until I do.",
  },
  {
    q: "How long until I see results?",
    a: "You'll usually see early movement in 3 to 4 months and real results by month 6 to 8. Anyone promising you page one in a week is lying to you.",
  },
  {
    q: "What's the difference between SEO and LLM visibility?",
    a: "SEO gets you found on Google. LLM visibility gets you named inside AI answers on tools like ChatGPT, Claude, Gemini and Perplexity. Your buyers use both now, so I work on both.",
  },
  {
    q: "Who is this for?",
    a: "Businesses that already sell something people want, and want more of the right people to find them without paying for every click.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="border-t border-black/10 px-6 sm:px-12 py-32 sm:py-40">
      <div className="grid grid-cols-12 gap-8 lg:gap-12">
        <div className="col-span-12 lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <FadeUp>
              <MonoLabel>Before you book</MonoLabel>
            </FadeUp>
            <h2 className="mt-6 font-display font-semibold text-4xl sm:text-5xl tracking-[-0.03em] leading-[1.06]">
              <MaskedLine>Fair questions.</MaskedLine>
              <MaskedLine delay={0.1}>
                <span className="text-gradient">Straight answers.</span>
              </MaskedLine>
            </h2>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-7 lg:col-start-6">
          <FadeUp>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-black/10"
                  data-testid={`faq-item-${i + 1}`}
                >
                  <AccordionTrigger
                    className="text-left font-display font-semibold text-lg sm:text-2xl tracking-[-0.02em] py-7 hover:no-underline hover:text-primary transition-colors duration-300"
                    data-testid={`faq-question-${i + 1}`}
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    className="text-muted-foreground text-base sm:text-lg leading-relaxed pb-7 max-w-xl"
                    data-testid={`faq-answer-${i + 1}`}
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
